import {eatClubClient} from "@globals/config/apiClient";

import {
  ExtrasMenuParams,
  GrabNGoMenuParams,
  InviteMenuParams,
  Menu,
  MenuFetcherParams,
  MenuParams,
  MenuType,
} from "./interfaces";

export function fetchMenu(params: MenuFetcherParams): Promise<Menu> {
  // Preview Menu is an internal tool (even though it lives in aphrodite)
  // so we need to remove "X-Is-Consumer-App" header
  const deleteHeaders = [
    (data: any, headers: any) => {
      delete headers["X-Is-Consumer-App"];
      return data;
    },
  ];

  // Returns menu item ids for item ids in response.items
  return eatClubClient
    .get("/menus/", {
      params,
      transformRequest:
        params?.menu_type === MenuType.Preview ? deleteHeaders : undefined,
    })
    .then((response) => response.data)
    .catch(({response}) => {
      const error = {
        status: response.status,
        message: response.data?.message,
        detail: response.data?.detail,
      };
      throw error;
    });
}

export function fetchInviteeMenu({
  inviteKey,
  ...cache_params
}: InviteMenuParams): Promise<Menu> {
  return fetchMenu({
    key: inviteKey,
    ...cache_params,
  });
}

export function fetchGrabNGoMenu({
  selectedDate,
  hubShortName,
  tenantSlug,
  ...cache_params
}: GrabNGoMenuParams): Promise<Menu> {
  return fetchMenu({
    date: selectedDate,
    hub: hubShortName,
    ignore_inventory: true,
    menu_type: MenuType.GrabNGo,
    tenant_slug: tenantSlug,
    ...cache_params,
  });
}

export function fetchPreviewMenu({
  selectedDate,
  hubShortName,
  tenantSlug,
  ...cache_params
}: GrabNGoMenuParams): Promise<Menu> {
  return fetchMenu({
    date: selectedDate,
    hub: hubShortName,
    ignore_inventory: true,
    menu_type: MenuType.Preview,
    tenant_slug: tenantSlug,
    ...cache_params,
  });
}

export function fetchExtrasMenu({
  selectedDate,
  locationId,
  ...cache_params
}: ExtrasMenuParams): Promise<Menu> {
  return fetchMenu({
    menu_type: MenuType.Extras,
    date: selectedDate,
    location_id: locationId,
    ...cache_params,
  });
}

export function fetchIndividualMenu({
  selectedDate,
  locationId,
  ...cache_params
}: ExtrasMenuParams): Promise<Menu> {
  return fetchMenu({
    menu_type: MenuType.Individual,
    date: selectedDate,
    location_id: locationId,
    ...cache_params,
  });
}

type MenuFetcher = (params: MenuParams | MenuFetcherParams) => Promise<Menu>;

export function getMenuFetcher(menuType: MenuType): MenuFetcher {
  switch (menuType) {
    case MenuType.Invitee:
      return fetchInviteeMenu;
    case MenuType.GrabNGo:
      return fetchGrabNGoMenu;
    case MenuType.Preview:
      return fetchPreviewMenu;
    case MenuType.Extras:
      return fetchExtrasMenu;
    case MenuType.Individual:
      return fetchIndividualMenu;
    default:
      return fetchMenu;
  }
}
